<template>
  <template v-if="editionMode">
    <div class="fm-form-input mt-2">
      <BaseLabelTop
        :target="name"
        :label="label ?? $t('attributes.gln_number')"
        :disabled="disabled"
        :required="required"
      />
      <input
        v-model="localModelValue"
        :name="name"
        :disabled="disabled"
        :placeholder="placeholder"
        type="text"
      />
      <BaseShowEditStatusBadge v-if="status !== 'unknown'" :status="status" />
    </div>
    <ErrorContainer :error-key="name" :errors="errors" />
  </template>
  <template v-else>
    <BaseShowLabel
      :label="label ?? $t('attributes.gln_number')"
      :model-value="localModelValue"
    />
  </template>
</template>

<script>
import BaseLabelTop from '@c/addf-package/components/BaseLabel/BaseLabelTop.vue'
import BaseShowLabel from '@c/addf-package/components/BaseLabel/BaseShowLabel.vue'
import ErrorContainer from '@c/addf-package/components/BaseShowEditInput/ErrorContainer.vue'
import BaseShowEditStatusBadge from '@c/addf-package/components/BaseShowEditInput/BaseShowEditStatusBadge.vue'
import { checkGln } from '@u/identifiers/companyIdentifiers'

/**
 * GLN with a check-digit verdict (BBSW-11615).
 *
 * A GLN is a GS1 code, the same 13 digits everywhere, so unlike the enterprise
 * number it is checked whatever the country. The verdict is shown, never
 * enforced: nothing here blocks the form from being submitted.
 */
export default {
  name: 'BaseShowEditGlnInput',
  components: {
    BaseLabelTop,
    BaseShowLabel,
    BaseShowEditStatusBadge,
    ErrorContainer
  },
  props: {
    modelValue: {
      type: String,
      default: null
    },
    errors: {
      type: Array,
      default: () => []
    },
    editionMode: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: 'gln_number'
    },
    label: {
      type: String,
      default: null
    },
    /** A valid example: it shows the format expected, digits need no translation. */
    placeholder: {
      type: String,
      default: '5400112000014'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  computed: {
    localModelValue: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    },
    status() {
      return checkGln(this.modelValue)
    }
  }
}
</script>
